import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { Typography, Row, Col } from 'antd';

import { email } from '../../../../attrs/content';

import { Container, Title, Body, Footer, List, ListItem, Link } from './style';

const ProfessionalService = () => (
  <Container>
    <Title>Professional Service</Title>
    <Body>
      <Typography.Paragraph>
        We offer a variety of additional services. Get in touch to learn more.
      </Typography.Paragraph>

      <Row>
        <Col md={8} sm={12} span={24}>
          <List>
            <ListItem>
              <CheckOutlined />
              Custom metrics
            </ListItem>
            <ListItem>
              <CheckOutlined />
              Custom on-chain queries
            </ListItem>
            <ListItem>
              <CheckOutlined />
              On-demand analyst
            </ListItem>
            <ListItem>
              <CheckOutlined />
              Early access to metrics
            </ListItem>
          </List>
        </Col>
        <Col md={8} sm={12} span={24}>
          <List>
            <ListItem>
              <CheckOutlined />
              Exclusive research
            </ListItem>
            <ListItem>
              <CheckOutlined />
              Onboarding & tech support
            </ListItem>
            <ListItem>
              <CheckOutlined />
              Infrastucture sharing
            </ListItem>
            <ListItem>
              <CheckOutlined />
              On-demand delivery formats
            </ListItem>
          </List>
        </Col>
      </Row>
    </Body>
    <Footer>
      <Link href={`mailto:${email}`}>Get in touch</Link>
    </Footer>
  </Container>
);

export default ProfessionalService;
